import React, { ReactNode } from 'react';
import { Badge } from '@americanexpress/dls-react';

type CardProps = {
  title: ReactNode;
  subtitle: ReactNode;
  image: string;
  imageAlt?: string;
  isNewOpening?: boolean;
};

const Card = ({
  title,
  subtitle,
  image,
  imageAlt,
  isNewOpening,
}: CardProps) => {
  return (
    <div className="tw-flex tw-h-full tw-min-h-fit tw-w-full tw-flex-1 tw-flex-col tw-items-start tw-self-stretch tw-rounded-2xl tw-border tw-border-blue-deep-tint-700-t12 tw-bg-blue-deep-surface-800-sb4 tw-transition-shadow tw-duration-200 focus-within_tw-shadow-md hover_tw-shadow-md hover_tw-duration-300">
      {/* Image */}
      <div className="tw-relative tw-w-full tw-self-stretch">
        <div className="tw-aspect-video tw-overflow-hidden tw-rounded-t-2xl">
          <img
            src={image}
            alt={imageAlt || (typeof title === 'string' ? title : '')}
            className="tw-h-full tw-w-full tw-object-cover"
          />
        </div>
        {isNewOpening && (
          <Badge
            size="large"
            status="information"
            type="text"
            className="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-border-blue-bright-200 tw-text-xs tw-font-bold first-child_tw-rounded-bl-none first-child_tw-rounded-br-2xl first-child_tw-rounded-tl-xl first-child_tw-rounded-tr-none first-child_tw-bg-blue-bright-100 first-child_tw-px-4 first-child_tw-py-2 first-child_tw-text-blue-bright-shade-600-s8"
            aria-hidden={true}
          >
            New Opening
          </Badge>
        )}
      </div>
      {/* Content */}
      <div className="tw-flex tw-flex-1 tw-flex-col tw-px-4 tw-py-5">
        <h3 className="tw-w-full tw-font-sans tw-text-xl tw-font-medium tw-text-gray-100">
          {title}
        </h3>
        <p className="tw-w-full tw-flex-1 tw-text-sm tw-font-normal tw-text-gray-300">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default Card;
